import dy from "./imgs/dynamite.jpg";
import ra from "./imgs/ranch.jpg";
import mar from "./imgs/margarita.jpg";
import mash from "./imgs/mashroom.jpg";
import sup from "./imgs/supreme.jpg";
import bbq from "./imgs/bbq.jpg";
import pep from "./imgs/peprone.jpg";
import veg from "./imgs/vegetable.jpg";

const data = {
  products: [
    {
      id: "1",
      pizzaName: "Dynamite Pizza",
      price: 32,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: dy,
    },
    {
      id: "2",
      pizzaName: "Ranch Pizza",
      price: 32,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: ra,
    },
    {
      id: "3",
      pizzaName: "Margarita Pizza",
      price: 29,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: mar,
    },
    {
      id: "4",
      pizzaName: "Mashroom Pizza",
      price: 30,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: mash,
    },
    {
      id: "5",
      pizzaName: "supereme Pizza",
      price: 35,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: sup,
    },
    {
      id: "6",
      pizzaName: "BBQ Pizza",
      price: 32,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: bbq,
    },
    {
      id: "7",
      pizzaName: "Pepperoni Pizza",
      price: 30,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: pep,
    },
    {
      id: "8",
      pizzaName: "vegetable Pizza",
      price: 29,
      des: "    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure aliquid magni dolores doloremque dolorum.",
      image: veg,
    },
  ],
};

export default data;
